import React from "react";
import { SidebarIcons } from "../StandardContentSidebar/SidebarIcons";


const settingmenus = [
  {
    id: 3,
    label: "SETTINGS",
    type: "collapsible",
    icon: SidebarIcons.SettingsIcon,
    children: [
      // {
      //   uri: "/settings/general",
      //   label: "General",
      //   type: "nav-item",
      //   icon: <SettingsIcon sx={{ fontSize: 18 }} />,
      // },
      //   {
      //       uri: "/settings/edit-company-profile",
      //       label: 'Edit Company Profile',
      //       type: "nav-item",
      //       icon: <FaUserEdit style={{fontSize: 18}}/>
      //   },
      {
        id: 64,
        uri: "/settings/edit-company-details",
        label: "Company Details",
        type: "nav-item",
        icon: SidebarIcons.CompanyDetailsIcon,
      },
      {
        id: 252,
        uri: "/hr/list-department",
        label: "Department",
        type: "nav-item",
        icon: SidebarIcons.DepartmentIcon,
      },

      {
        id: 66,
        uri: "/hr/list-cadre-level",
        label: "Level/Cadre",
        type: "nav-item",
        icon: SidebarIcons.CadreIcon,
      },
      {
        id: 253,
        uri: "/hr/list-designation",
        label: "Designation",
        type: "nav-item",
        icon: SidebarIcons.DesignationIcon,
      },
      {
        id: 258,
        uri: "/hr/list-employee",
        label: "Employee Profile",
        type: "nav-item",
        icon: SidebarIcons.EmployeeMasterIcon,
      },
      {
        id: 65,
        uri: "/settings/roles",
        label: "Roles",
        type: "nav-item",
        icon: SidebarIcons.RolesIcon,
      },
      {
        id: 246,
        uri: "/settings/roles&users",
        label: "Invite User",
        type: "nav-item",
        icon: SidebarIcons.UserIcon,
      },

      {
        id: 208,
        uri: "/settings/holiday-lists",
        label: "Holiday List",
        type: "nav-item",
        icon: SidebarIcons.HolidaysIcon,
      },
      {
        label: "Statutory Components",
        type: "collapsible",
        icon: SidebarIcons.StatutoryAdminIcon,
        children: [
          {
            id: 261,
            uri: "/hr/employee-provident-fund",
            label: "Employee Provident Fund",
            type: "nav-item",
            icon: SidebarIcons.ProvidentFundIcon,
          },
          {
            id: 257,
            uri: "/hr/employee-state-insurance",
            label: "Employee State Insurance",
            type: "nav-item",
            icon: SidebarIcons.ESIIcon,
          },
          {
            id: 260,
            uri: "/hr/professional-tax",
            label: "Professional Tax",
            type: "nav-item",
            icon: SidebarIcons.ProfessionalTaxIcon,
          },

          {
            label: "Salary Component",
            type: "collapsible",
            icon: SidebarIcons.SalaryComponentAdminIcon,
            children: [
              {
                id: 256,
                uri: "/hr/salary-earnings",
                label: "Earnings",
                type: "nav-item",
                icon: SidebarIcons.EarningsIcon,
              },
              {
                id: 255,
                uri: "/hr/salary-deductions",
                label: "Deductions",
                type: "nav-item",
                icon: SidebarIcons.DeductionsIcon,
              },
            ],
          },
        ],
      },
      // {
      //   uri: "/settings/roles&users",
      //   label: "Roles & Users",
      //   type: "nav-item",
      //   icon: <FaHouseUser style={{ fontSize: 18 }} />,
      // },
      // {
      //   uri: "/settings/transaction-approval",
      //   label: "Transaction Approval",
      //   type: "nav-item",
      //   icon: <AiOutlineTransaction style={{ fontSize: 18 }} />,
      // },
      {
        label: "Preferences",
        type: "collapsible",
        icon: SidebarIcons.PreferenceIcon,
        children: [
          {
            id: 209,
            uri: "/settings/preferences/transaction-series",
            label: "Transaction Series",
            type: "nav-item",
            icon: SidebarIcons.TransactionSeriesIcon,
          },
          {
            id: 209,
            uri: "/settings/ListMailConfiguration",
            label: "Mail Configuration",
            type: "nav-item",
            icon: SidebarIcons.MailConfigurationIcon,
          },
          // {
          //   id: 70,
          //   uri: "/settings/preferences/items",
          //   label: "Items",
          //   type: "nav-item",
          //   icon: <HiTemplate style={{ fontSize: 16, marginLeft: 15 }} />,
          // },

          // {
          //   id: 72,
          //   uri: "/settings/preferences/sales-order",
          //   label: "Sales Order",
          //   type: "nav-item",
          //   icon: <LoyaltyIcon sx={{ fontSize: 16, ml: 2 }} />,
          // },
          // {
          //   uri: "/service/list-subscription",
          //   label: "Subscription",
          //   type: "nav-item",
          //   icon: SidebarIcons.TaskCalendarIcon,
          // },
          // {
          //   id: 69,
          //   uri: "/settings/preferences/invoice",
          //   label: "Invoice",
          //   type: "nav-item",
          //   icon: <DescriptionIcon sx={{ fontSize: 16, ml: 2 }} />,
          // },
          // {
          //   id: 71,
          //   uri: "/settings/preferences/purchase-order",
          //   label: "Purchase Order",
          //   type: "nav-item",
          //   icon: <GiShinyPurse style={{ fontSize: 16, marginLeft: 15 }} />,
          // },
          // {
          //   uri: "/settings/preferences/budget",
          //   label: "Budget",
          //   type: "nav-item",
          //   icon: (
          //     <FaMoneyBillWaveAlt style={{ fontSize: 16, marginLeft: 15 }} />
          //   ),
          // },
          // {
          //   id: 68,
          //   uri: "/settings/preferences/inventory",
          //   label: "Inventory",
          //   type: "nav-item",
          //   icon: (
          //     <BiCategory
          //       style={{ fontSize: 16, marginLeft: 15 }}
          //     />
          //   ),
          // },
          // {
          //   id: 210,
          //   uri: "/settings/preferences/budgetlock",
          //   label: "Budget Lock",
          //   type: "nav-item",
          //   icon: <GiShinyPurse style={{ fontSize: 16, marginLeft: 15 }} />,
          // },
        ],
      },
      {
        id: 211,
        uri: "/settings/item-lookup-category",
        label: "Lookup",
        // label: "Dropdown Values",
        type: "nav-item",
        icon: SidebarIcons.LookupIcon,
      },
      {
        id: 212,
        uri: "/settings/list-cost-centre",
        label: "Cost Centre",
        type: "nav-item",
        icon: SidebarIcons.CostCentreIcon,
      },
      {
        id: 213,
        uri: "/notification/content",
        label: "Notification Content",
        type: "nav-item",
        icon: SidebarIcons.LookupIcon,
      },
      {
        id: 214,
        uri: "/settings/ListAccountPeriod",
        label: "Account Period",
        type: "nav-item",
        icon: SidebarIcons.AccountPeriodIcon,
      },
      {
        id: 215,
        uri: "/settings/YearEndProcess",
        label: "Year End Process",
        type: "nav-item",
        icon: SidebarIcons.YearEndProcessIcon,
      },

      {
        id: 225,
        uri: "/setting/tdssetup",
        label: "TDS SetUp",
        type: "nav-item",
        icon: SidebarIcons.TDSSetupIcon,
      },
      // {
      //   id: 226,
      //   uri: "/settings/slot-time-list",
      //   label: "Slot Time",
      //   type: "nav-item",
      //   icon: <AlarmAddIcon sx={{ fontSize: 18 }} />,
      // },
      // {
      //   id: 74,
      //   uri: "/settings/SmsTemplate",
      //   label: "DLT Template",
      //   type: "nav-item",
      //   icon: SidebarIcons.LookupIcon,
      // },
      {
        id: 74,
        uri: "/settings/list-templates",
        label: "Templates",
        type: "nav-item",
        icon: SidebarIcons.LookupIcon,
      },

      {
        id: 75,
        label: "Workflow",
        type: "collapsible",
        icon: SidebarIcons.WorkflowIcon,
        children: [
          {
            id: 75,
            uri: "/settings/workflow-rules",
            label: "Workflow Rules",
            type: "nav-item",
            icon: SidebarIcons.WorkflowRuleIcon,
          },
          {
            id: 75,
            uri: "/settings/workflow",
            label: "Workflow",
            type: "nav-item",
            icon: SidebarIcons.WorkflowRuleIcon,
          },
          {
            id: 75,
            uri: "/settings/assign-workflow",
            label: "Assign Workflow",
            type: "nav-item",
            icon: SidebarIcons.WorkflowRuleIcon,
          },
          {
            id: 75,
            uri: "/settings/partner-workflow",
            label: "Workflow Approver Assignment",
            type: "nav-item",
            icon: SidebarIcons.WorkflowRuleIcon,
          },
        ],
      },
      // {
      //   id: 227,
      //   uri: "/settings/organization-structure",
      //   label: "Organization Structure",
      //   type: "nav-item",
      //   icon: SidebarIcons.LookupIcon,
      // },
    ],
  },
];


export default settingmenus;
